export type LaikaChatErrorI18nKey =
  | 'errorTimeout'
  | 'errorNetwork'
  | 'errorTechnical'
  | 'errorUnknown';

/** Map fetch/stream failures to messaging.json chatWidget keys. */
export function laikaChatErrorI18nKey(
  error: { name?: string; message?: string } | null | undefined,
): LaikaChatErrorI18nKey {
  const name = String(error?.name || '');
  const msg = String(error?.message || '');
  if (name === 'AbortError' || msg === 'AbortError' || msg === 'timeout') {
    return 'errorTimeout';
  }
  if (/failed to fetch|networkerror|load failed/i.test(msg)) {
    return 'errorNetwork';
  }
  if (
    /^\d{3}\b/.test(msg) ||
    msg === 'error' ||
    /stream|empty body|missing final|internal server/i.test(msg)
  ) {
    return 'errorTechnical';
  }
  return 'errorUnknown';
}
